export class UnsetGradingSchemeFromModuleSuccess {
    static readonly type = '[GradingScheme] UnsetGradingSchemeFromModuleSuccess';
}
